// @flow
import type CompositeAttributeChildCollection from "../CompositeAttributeChildCollection";

import type { IConstraintModel, AttributeType } from "../../types";

/**
 */
class MandatoryRangeConstraint implements IConstraintModel {
  _type: string;
  _children: CompositeAttributeChildCollection;

  /**
   */
  constructor(type: string, children: CompositeAttributeChildCollection) {
    this._type = type;
    this._children = children;
  }

  /**
   */
  get type(): string {
    return this._type;
  }

  /**
   */
  get children(): Array<AttributeType> {
    return this._children.all;
  }

  /**
   */
  get id(): string {
    switch (this.type) {
      case "date":
        return "Constraint.DateRange.Mandatory";
      case "time":
        return "Constraint.TimeRange.Mandatory";
      case "datetime":
        return "Constraint.DateTimeRange.Mandatory";
      case "timestamp":
        return "Constraint.TimeStampRange.Mandatory";
      default:
        return "Constraint.Range.Mandatory";
    }
  }

  /**
   */
  hasValidation(): boolean {
    return true;
  }

  /**
   */
  get defaultMessage(): string {
    return "Field is mandatory: must contain at least a start or end value";
  }

  /**
   */
  get parameters(): { ... } {
    return {};
  }

  /**
   */
  validate(): boolean {
    // only validate when no children are in error
    if (this.children.some((child) => child.inError())) {
      return true;
    }

    return this.children.some((child) => child.hasValue());
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return true;
  }
}

export default MandatoryRangeConstraint;
